"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getters = {
  getLenses: function getLenses(state) {
    return state.lenses;
  },
  getFrame: function getFrame(state) {
    return state.frame;
  },
  getNonPrescriptionLens: function getNonPrescriptionLens(state) {
    return state.nonPrescriptionLens;
  },
  getActiveLenses: function getActiveLenses(state) {
    return state.activeLenses;
  },
  getfinalLens: function getfinalLens(state) {
    return state.finalLens;
  }
};

exports.default = getters;